import configs from "@/i18n/configs"
export default {
    'this-double-visit-report': 'this Double visit report',
    'add-new-report': 'Add new report',
    'view-report': 'View report',
    'delete-report': 'Delete report',
    'pre-call-analysis': `${configs.preCallAnalysis.en}`,
    call: `${configs.call.en}`
}